import * as Sentry from "@sentry/svelte"
import { Capacitor } from "@capacitor/core"
import { useRegisterSW } from "virtual:pwa-register/svelte"
import "@utils/underhood/pwa-prompt"

import "../styles.css"
import "@utils/underhood/disable-context-menu"
import { browser } from "$app/environment"
import {
    cleanupNativeServiceWorkerState,
    updateServiceWorkerIfAvailable,
} from "@utils/underhood/service-worker"

export const prerender = false
export const ssr = false

if (_mode !== "development") {
    const release = "acimce-kit@" + _sentryReleaseVersion
    const environment = _mode
    // Initialize the Sentry SDK here
    Sentry.init({
        dsn: "https://d3f86a69067f4cc58f57ff0807caa0d1@o4504135362412544.ingest.sentry.io/4505201612554240",
        // integrations: [new Sentry.BrowserTracing() /*, new Sentry.Replay() - replay slows down the app a lot with mutations */],
        environment,

        release,
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performan    ce monitoring.
        // We recommend adjusting this value in production
        replaysSessionSampleRate: 0.1, // This sets the Replay sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        tracesSampleRate: 1.0,
    })

    console.log(`✨ ${release} / ${environment}`)
}

Sentry.setTag("platform", Capacitor.getPlatform())

if (browser && Capacitor.isNativePlatform()) {
    void cleanupNativeServiceWorkerState()
        .then(({ registrationsFound, registrationsRemoved, cachesRemoved }) => {
            if (registrationsFound || cachesRemoved) {
                console.info("Removed native PWA service worker state", {
                    registrationsFound,
                    registrationsRemoved,
                    cachesRemoved,
                })
            }
        })
        .catch((error) => console.warn("Failed to remove native PWA service worker state", error))
}

if (browser && !Capacitor.isNativePlatform()) {
    const intervalMS = 60 * 60 * 1000
    useRegisterSW({
        onRegisteredSW(swUrl, registration) {
            if (!registration) return

            let updateInProgress = false
            setInterval(async () => {
                if (updateInProgress) return
                updateInProgress = true
                await updateServiceWorkerIfAvailable(swUrl, registration)
                updateInProgress = false
            }, intervalMS)
        },
        onRegisterError(error) {
            console.warn("Service worker registration failed", error)
        },
    })
}

// For transitions ?
export function load({ url }: { url: URL }) {
    return {
        url: url.pathname,
    }
}

// DEBUG

// globalThis.spoofDate = (minutes) => {
//     globalThis.oldDate = globalThis.oldDate || Date // Save the original Date constructor

//     // Redefine the Date constructor
//     globalThis.Date = class extends Date {
//         constructor(...args) {
//             if (args.length) {
//                 // If arguments are provided, use them to construct a new Date
//                 super(...args)
//             } else {
//                 // No arguments mean we want the current date, adjusted by 'minutes'
//                 const adjustedDate = new globalThis.oldDate()
//                 adjustedDate.setMinutes(adjustedDate.getMinutes() + minutes)
//                 return adjustedDate
//             }
//         }
//     }
// }
